import React, {useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import {Grid, Card, CardMedia, CardContent, CardActions, Typography, Grow } from '@mui/material';
import Tmdb from '../../lib/Tmdb';
import EpisodeCard from '../EpisodeCard/EpisodeCard';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../MovieRow/style.css'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 2, // optional, default to 1.
      partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.

    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const Seasons = ({item, serieId, handleIframe})=>{
    const Headers = styled("div")(({ theme }) => ({
        display:"flex",
        flexWrap:"wrap",
        color:"#fff",
        fontSize:"2rem"
        
      }));
      const [episodeList, setEpisodeList] = useState(null);

    useEffect(()=>{
        const loadItem = async () =>{
            let seasonDetail = await Tmdb.getSeasonsInfo(serieId, 'tv', item.season_number);
            setEpisodeList(seasonDetail)
         }
         loadItem();

      },[]);
 return(
     <>

        {episodeList == null?
        <div></div>
        :
        <Carousel
        partialVisible={true}
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={false} // means to render carousel on server-side.
        infinite={true}
        autoPlay={false}
        keyBoardControl={true}
        customTransition="transform 300ms ease-in-out"
        transitionDuration={300}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        className='customer-carousel'
      >
        {episodeList.episodes.map((item,key)=>(
            <EpisodeCard key={key} item={item} serieId={serieId} handleIframe={handleIframe}/>
        ))} 
        </Carousel>
       
        }
      
     </>
 );   
}

export default Seasons;